/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Phase_Closed_ErrorInputs */

const en_application_phase_closed_error = /** @type {(inputs: Application_Phase_Closed_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The application phase has ended. New applications can no longer be submitted.`)
};

const de_application_phase_closed_error = /** @type {(inputs: Application_Phase_Closed_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bewerbungsphase ist beendet. Es können keine neuen Bewerbungen mehr eingereicht werden.`)
};

/**
* | output |
* | --- |
* | "The application phase has ended. New applications can no longer be submitted." |
*
* @param {Application_Phase_Closed_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_phase_closed_error = /** @type {((inputs?: Application_Phase_Closed_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Phase_Closed_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_phase_closed_error(inputs)
	return en_application_phase_closed_error(inputs)
});